<template>
    <div>
        <div class="newIccStyles" id="contentParent">
            <content-section
                @sectionSortOrderChanged="$emit('sectionSortOrderChanged', $event)"
                v-for="contentSection in contentSections"
                :is-notes-section-expanded="isNotesSectionExpanded"
                :key="contentSection.sectionId"
                :contentSection="contentSection"
                @breadcrumb-clicked="handleBreadcrumbClick"
                :contentModifiers="contentModifiers"
                :showAllBookmarks="showAllBookmarks"
                :renderToolbar="renderToolbar"
                :showNoteControlMenu="showNoteControlMenu"
                :userBookmarksDefaultSortOrder="getUserBookmarkSortOrderForContentSection(contentSection)"
                :highlightType="highlightType"
                :showTitleAsLink="showTitleAsLink"
                :displayBreadCrumbs="displayBreadCrumbs"
                :displaySectionSeparated="displaySectionSeparated"
            />
        </div>
        <template v-if="registerDialogs">
            <peak-ahead/>
            <astm-modal/>
            <note-bookmark-modals/>
            <premium-tools-access-restriction-modal/>
            <toolbar-actions-view-mobile/>
        </template>

    </div>
</template>

<script>
import ContentSection from "./ContentSection.vue";
import ContentSectionType from "./types/contentSectionType";
import PeakAhead from "../../components/titles/peakAhead/index.vue";
import AstmModal from '../modals/astmModal.vue';
import DefaultContentModifier from "./content-modifiers/DefaultContentModifier";
import RemoveContentLinksModifier from "./content-modifiers/RemoveContentLinksModifier";
import ContentUtils from "../titles/inc/contentUtils";
import Constants from "../../constants";
import helper from "../inc/mixins/helper";
import ContentSectionBreadcrumb from "./ContentSectionBreadcrumb.vue";
import PremiumToolsAccessRestrictionModal from "../modals/PremiumToolsAccessRestrictionModal.vue";
import NoteBookmarkModals from "./Dialogs/index.vue";
import ToolbarActionsViewMobile from "./ToolbarActionsViewMobile.vue";

export default {
    components: {
        PremiumToolsAccessRestrictionModal,
        ContentSectionBreadcrumb,
        ContentSection,
        NoteBookmarkModals,
        PeakAhead,
        AstmModal,
        ToolbarActionsViewMobile
    },
    props: {
        /**
         * @type {Array<ContentSectionType>}
         */
        contentSections: {
            required: true,
            type: Array
        },
        isNotesSectionExpanded: {
            type: Boolean,
            required: false,
            default: false
        },
        showAllBookmarks: {
            type: Boolean,
            default: false
        },
        renderToolbar: {
            type: Boolean,
            default: true
        },
        showNoteControlMenu: {
            type: Boolean,
            default: true
        },
        customUserBookmarksSorOrders: {
            type: Object,
            required: false
        },
        registerDialogs: {
            type: Boolean,
            required: false,
            default: true
        },
        /**
         * @type {import('vue').PropType<'none' | 'add-note' | 'insert-into'>}
         */
        highlightType: {
            type: String,
            required: false,
            default: 'none',
            validator: (value) => ['none', 'add-note', 'insert-into'].includes(value)
        },
        showTitleAsLink: {
            type: Boolean,
            default: true
        },
        displayBreadCrumbs: {
            type: Boolean,
            default: true
        },
        hideContentLinks: {
            type: Boolean,
            default: false
        },
        displaySectionSeparated: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        contentModifiers() {
            return this.hideContentLinks ? [new RemoveContentLinksModifier()] : this.getContentModifiers() ;
        }
    },
    methods: {
        getUserBookmarkSortOrderForContentSection(contentSection) {
            return this.customUserBookmarksSorOrders?.[contentSection.sectionId] || 'desc';
        },
        handleBreadcrumbClick(breadcrumbItem) {
            // TODO:: For search we will record the breadcrumb click to gtm and the backend
        },
        getContentModifiers() {
            //TODO:: this should be refactored
            const defaultContentModifier = new DefaultContentModifier(Routing, this.$http, ContentUtils, helper, Constants, _);
            return [defaultContentModifier];
        },
    }
}

</script>
